import { render, staticRenderFns } from "./PositionalAudioEditor.vue?vue&type=template&id=6f714249&"
import script from "./PositionalAudioEditor.vue?vue&type=script&lang=ts&"
export * from "./PositionalAudioEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports